"use client";

import { POIType } from "../types/index";
import { Html } from "@react-three/drei";

export default function POI({ poiContent, onPOIClick }: { poiContent: POIType; onPOIClick: (poi: POIType) => void }) {
	const SelectPOI = () => {
		onPOIClick(poiContent);
	};

	return (
		// <mesh position={[poiContent.position.x, poiContent.position.y, poiContent.position.z]}>
		<Html position={[poiContent.position.x, poiContent.position.y, poiContent.position.z]}>
			<div>
				<button className="html-poi" title="Wissenssnack" onClick={SelectPOI}></button>
			</div>
		</Html>
		// </mesh>
	);
	// ;
}
